/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * BellIcon
 */
export default class BellIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M12 2c4.18 0 8 3.62 8 6v7.816c.047.06.117.136.207.227.294.294.76.683 1.393 1.157l.025.02a1 1 0 01-.509 1.774L21 19h-6a3 3 0 01-5.995.176L9 19H3a1 1 0 01-.601-1.8c.633-.474 1.1-.863 1.394-1.157.09-.09.16-.168.207-.227V8c0-2.38 3.82-6 8-6zm1 17h-2a1 1 0 001.993.117L13 19zM12 4c-1.742 0-3.275.69-4.5 1.851C6.622 6.683 6 7.735 6 8v8c0 .335-.121.654-.38 1h12.76c-.259-.346-.38-.665-.38-1V8c0-.265-.622-1.317-1.5-2.149C15.275 4.691 13.742 4 12 4z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

